import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { At, Emoji, SendFilled } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { useBreakpointsContext } from "@air/provider-media-query";
import classNames from "classnames";
import dynamic from "next/dynamic";
import { memo } from "react";
const EmojiMenu = dynamic(()=>import("@air/component-emoji-menu").then((mod)=>mod.EmojiMenu), {
    loadableGenerated: {
        webpack: ()=>[
                require.resolveWeak("@air/component-emoji-menu")
            ]
    },
    ssr: false
});
import { DISCUSSION_FORM_BUTTON_CANCEL, DISCUSSION_FORM_BUTTON_SUBMIT, DISCUSSION_FORM_BUTTONS_CONTAINER } from "~/constants/testIDs";
export const CommentActions = /*#__PURE__*/ memo((param)=>{
    let { onCancel, onEmojiPick, hasCancelButton, isDisabled, addTriggerProgrammatically, shouldShowMentionsButton = true, hasInternalAvatar } = param;
    const { isAboveMediumScreen } = useBreakpointsContext();
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("ml-1 flex max-h-[40px] flex-1 items-center justify-end gap-2", hasInternalAvatar ? "mr-0 mt-1" : "mr-1 mt-0"),
        "data-testid": DISCUSSION_FORM_BUTTONS_CONTAINER,
        children: [
            hasCancelButton && /*#__PURE__*/ _jsx(Button, {
                appearance: "ghost",
                color: "grey",
                "data-testid": DISCUSSION_FORM_BUTTON_CANCEL,
                onClick: onCancel,
                size: "small",
                children: "Cancel"
            }),
            isAboveMediumScreen && /*#__PURE__*/ _jsx(EmojiMenu, {
                trigger: /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    color: "grey",
                    label: "Insert emoji",
                    icon: Emoji,
                    size: "small"
                }),
                onSelect: (emoji)=>onEmojiPick(emoji.native)
            }),
            shouldShowMentionsButton && /*#__PURE__*/ _jsx(Tooltip, {
                label: "Mention someone",
                side: "top",
                children: /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    color: "grey",
                    label: "Mention",
                    size: "small",
                    onClick: addTriggerProgrammatically,
                    icon: At
                })
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "filled",
                color: "blue",
                "data-testid": DISCUSSION_FORM_BUTTON_SUBMIT,
                disabled: isDisabled,
                icon: SendFilled,
                label: "Send",
                size: "small",
                type: "submit"
            })
        ]
    });
});
CommentActions.displayName = "CommentActions";
